export const diseases_bwcdiamond_eng = [
  {
    label: 'Asthma',
    label_show: 'Asthma',
    page: 7,
    Xpos_image: '296px',
    Ypos_image: '480px',
    Xlabel: '309px',
    Ylabel: '555px',
    width: '70px',
    height: 'auto',
    result_comp: [
      { min: 0, max: 3, image: 'asthma_0' },
      { min: 4, max: 6, image: 'asthma_1' },
      { min: 7, max: 100, image: 'asthma_2' }
    ]
  },
  {
      label: 'Food allergy',
      label_show: 'Food Allergy',
      page: 7,
      Xpos_image: '559px',
      Ypos_image: '480px',
      Xlabel: '561px',
      Ylabel: '555px',
      width: '70px',
      height: 'auto',
      result_comp: [
        { min: 0, max: 3, image: 'foodallergy_0' },
        { min: 4, max: 6, image: 'foodallergy_1' },
        { min: 7, max: 100, image: 'foodallergy_2' }
      ]
    },
    {
      label: 'Eczema',
      label_show: 'Eczema',
      page: 7,
      Xpos_image: '428px',
      Ypos_image: '480px',
      Xlabel: '442px',
      Ylabel: '555px',
      width: '70px',
      height: 'auto',
      result_comp: [
        { min: 0, max: 3, image: 'eczema_0' },
        { min: 4, max: 6, image: 'eczema_1' },
        { min: 7, max: 100, image: 'eczema_2' }
      ]
    },
    {
      label: 'Allergic rhinitis',
      label_show: 'Allergic Rhinitis',
      page: 7,
      Xpos_image: '165px',
      Ypos_image: '480px',
      Xlabel: '159px',
      Ylabel: '555px',
      width: '70px',
      height: 'auto',
      result_comp: [
        { min: 0, max: 3, image: 'allergicrhiniitis_0' },
        { min: 4, max: 6, image: 'allergicrhiniitis_1' },
        { min: 7, max: 100, image: 'allergicrhiniitis_2' }
      ]
    },
    {
      label: 'Overweight',
      label_show: 'Obesity',
      page: 7,
      Xpos_image: '296px',
      Ypos_image: '605px',
      Xlabel: '309px',
      Ylabel: '680px',
      width: '70px',
      height: 'auto',
      result_comp: [
        { min: 0, max: 3, image: 'overweight_0' },
        { min: 4, max: 6, image: 'overweight_1' },
        { min: 7, max: 100, image: 'overweight_2' }
      ]
    },
    {
      label: 'Metabolic syndrome',
      label_show: 'Dyslipidemia',
      page: 7,
      Xpos_image: '165px',
      Ypos_image: '605px',
      Xlabel: '165px',
      Ylabel: '680px',
      width: '70px',
      height: 'auto',
      result_comp: [
        { min: 0, max: 3, image: 'metabolicsyndrome_0' },
        { min: 4, max: 6, image: 'metabolicsyndrome_1' },
        { min: 7, max: 100, image: 'metabolicsyndrome_2' }
      ]
    },
    {
      label: 'Type 2 diabetes',
      label_show: ['Type 2', 'Diabetes'],
      page: 7,
      Xpos_image: '428px',
      Ypos_image: '605px',
      Xlabel: '438px',
      Ylabel: '680px',
      width: '70px',
      height: 'auto',
      result_comp: [
        { min: 0, max: 3, image: 'type2diabetes_0' },
        { min: 4, max: 6, image: 'type2diabetes_1' },
        { min: 7, max: 100, image: 'type2diabetes_2' }
      ]
    },
    {
      label: 'Excessive lipopolysaccharide',
      label_show: ['Excessive', 'Lipopolysaccharide'],
      page: 7,
      Xpos_image: '559px',
      Ypos_image: '605px',
      Xlabel: '541px',
      Ylabel: '680px',
      width: '70px',
      height: 'auto',
      result_comp: [
        { min: 0, max: 3, image: 'excessivelipopolysaccharide_0' },
        { min: 4, max: 6, image: 'excessivelipopolysaccharide_1' },
        { min: 7, max: 100, image: 'excessivelipopolysaccharide_2' }
      ]
    },
    {
      label: 'Constipation',
      label_show: 'Constipation',
      page: 7,
      Xpos_image: '230px',
      Ypos_image: '731px',
      Xlabel: '230px',
      Ylabel: '806px',
      width: '70px',
      height: 'auto',
      result_comp: [
        { min: 0, max: 3, image: 'constipation_0' },
        { min: 4, max: 6, image: 'constipation_1' },
        { min: 7, max: 100, image: 'constipation_2' }
      ]
    },
    {
      label: 'Diarrhea',
      label_show: 'Diarrhea',
      page: 7,
      Xpos_image: '361px',
      Ypos_image: '731px',
      Xlabel: '373px',
      Ylabel: '806px',
      width: '70px',
      height: 'auto',
      result_comp: [
        { min: 0, max: 3, image: 'diarrhea_0' },
        { min: 4, max: 6, image: 'diarrhea_1' },
        { min: 7, max: 100, image: 'diarrhea_2' }
      ]
    },
    {
      label: 'Immune disorder',
      label_show: 'Immune Dysfunction',
      page: 7,
      Xpos_image: '493px',
      Ypos_image: '731px',
      Xlabel: '471px',
      Ylabel: '806px',
      width: '70px',
      height: 'auto',
      result_comp: [
        { min: 0, max: 3, image: 'immunedisorder_0' },
        { min: 4, max: 6, image: 'immunedisorder_1' },
        { min: 7, max: 100, image: 'immunedisorder_2' }
      ]
    },
    {
      label: 'Insomnia/ poor sleep quality',
      label_show: ['Insomnia/ Poor', 'sleep quality'],
      page: 7,
      Xpos_image: '295px',
      Ypos_image: '858px',
      Xlabel: '287px',
      Ylabel: '933px',
      width: '70px',
      height: 'auto',
      result_comp: [
        { min: 0, max: 3, image: 'insommnia_0' },
        { min: 4, max: 6, image: 'insommnia_1' },
        { min: 7, max: 100, image: 'insommnia_2' }
      ]
    },
    {
      label: 'Stress and anxiety',
      label_show: ['Stress and', 'Anxiety'],
      page: 7,
      Xpos_image: '426px',
      Ypos_image: '858px',
      Xlabel: '432px',
      Ylabel: '933px',
      width: '70px',
      height: 'auto',
      result_comp: [
        { min: 0, max: 3, image: 'stress_0' },
        { min: 4, max: 6, image: 'stress_1' },
        { min: 7, max: 100, image: 'stress_2' }
      ]
    },
]

export const diseases_bwcdiamond_thai = [
  {
    label: 'Asthma',
    label_show: 'หอบหืด',
    page: 6,
    Xpos_image: '296px',
    Ypos_image: '480px',
    Xlabel: '311px',
    Ylabel: '555px',
    width: '70px',
    height: 'auto',
    result_comp: [
      { min: 0, max: 3, image: 'asthma_0' },
      { min: 4, max: 6, image: 'asthma_1' },
      { min: 7, max: 100, image: 'asthma_2' }
    ]
  },
  {
      label: 'Food allergy',
      label_show: 'ภูมิแพ้อาหาร',
      page: 6,
      Xpos_image: '559px',
      Ypos_image: '480px',
      Xlabel: '562px',
      Ylabel: '555px',
      width: '70px',
      height: 'auto',
      result_comp: [
        { min: 0, max: 3, image: 'foodallergy_0' },
        { min: 4, max: 6, image: 'foodallergy_1' },
        { min: 7, max: 100, image: 'foodallergy_2' }
      ]
    },
    {
      label: 'Eczema',
      label_show: 'ภูมิแพ้ผิวหนังอักเสบ',
      page: 6,
      Xpos_image: '428px',
      Ypos_image: '480px',
      Xlabel: '415px',
      Ylabel: '555px',
      width: '70px',
      height: 'auto',
      result_comp: [
        { min: 0, max: 3, image: 'eczema_0' },
        { min: 4, max: 6, image: 'eczema_1' },
        { min: 7, max: 100, image: 'eczema_2' }
      ]
    },
    {
      label: 'Allergic rhinitis',
      label_show: 'ภูมิแพ้อากาศ',
      page: 6,
      Xpos_image: '165px',
      Ypos_image: '480px',
      Xlabel: '166px',
      Ylabel: '555px',
      width: '70px',
      height: 'auto',
      result_comp: [
        { min: 0, max: 3, image: 'allergicrhiniitis_0' },
        { min: 4, max: 6, image: 'allergicrhiniitis_1' },
        { min: 7, max: 100, image: 'allergicrhiniitis_2' }
      ]
    },
    {
      label: 'Overweight',
      label_show: 'น้ำหนักเกิน',
      page: 6,
      Xpos_image: '296px',
      Ypos_image: '605px',
      Xlabel: '304px',
      Ylabel: '680px',
      width: '70px',
      height: 'auto',
      result_comp: [
        { min: 0, max: 3, image: 'overweight_0' },
        { min: 4, max: 6, image: 'overweight_1' },
        { min: 7, max: 100, image: 'overweight_2' }
      ]
    },
    {
      label: 'Metabolic syndrome',
      label_show: 'ไขมันในเลือดผิดปกติ',
      page: 6,
      Xpos_image: '165px',
      Ypos_image: '605px',
      Xlabel: '149px',
      Ylabel: '680px',
      width: '70px',
      height: 'auto',
      result_comp: [
        { min: 0, max: 3, image: 'metabolicsyndrome_0' },
        { min: 4, max: 6, image: 'metabolicsyndrome_1' },
        { min: 7, max: 100, image: 'metabolicsyndrome_2' }
      ]
    },
    {
      label: 'Type 2 diabetes',
      label_show: ['เบาหวาน','ประเภท 2'],
      page: 6,
      Xpos_image: '428px',
      Ypos_image: '605px',
      Xlabel: '438px',
      Ylabel: '680px',
      width: '70px',
      height: 'auto',
      result_comp: [
        { min: 0, max: 3, image: 'type2diabetes_0' },
        { min: 4, max: 6, image: 'type2diabetes_1' },
        { min: 7, max: 100, image: 'type2diabetes_2' }
      ]
    },
    {
      label: 'Excessive lipopolysaccharide',
      label_show: 'สาร Lipopolysaccharide สูง',
      page: 6,
      Xpos_image: '559px',
      Ypos_image: '605px',
      Xlabel: '520px',
      Ylabel: '680px',
      width: '70px',
      height: 'auto',
      result_comp: [
        { min: 0, max: 3, image: 'excessivelipopolysaccharide_0' },
        { min: 4, max: 6, image: 'excessivelipopolysaccharide_1' },
        { min: 7, max: 100, image: 'excessivelipopolysaccharide_2' }
      ]
    },
    {
      label: 'Constipation',
      label_show: 'ท้องผูก',
      page: 6,
      Xpos_image: '230px',
      Ypos_image: '731px',
      Xlabel: '245px',
      Ylabel: '806px',
      width: '70px',
      height: 'auto',
      result_comp: [
        { min: 0, max: 3, image: 'constipation_0' },
        { min: 4, max: 6, image: 'constipation_1' },
        { min: 7, max: 100, image: 'constipation_2' }
      ]
    },
    {
      label: 'Diarrhea',
      label_show: 'ท้องเสีย',
      page: 6,
      Xpos_image: '361px',
      Ypos_image: '731px',
      Xlabel: '374px',
      Ylabel: '806px',
      width: '70px',
      height: 'auto',
      result_comp: [
        { min: 0, max: 3, image: 'diarrhea_0' },
        { min: 4, max: 6, image: 'diarrhea_1' },
        { min: 7, max: 100, image: 'diarrhea_2' }
      ]
    },
    {
      label: 'Immune disorder',
      label_show: 'ภูมิคุ้มกันบกพร่อง',
      page: 6,
      Xpos_image: '493px',
      Ypos_image: '731px',
      Xlabel: '480px',
      Ylabel: '806px',
      width: '70px',
      height: 'auto',
      result_comp: [
        { min: 0, max: 3, image: 'immunedisorder_0' },
        { min: 4, max: 6, image: 'immunedisorder_1' },
        { min: 7, max: 100, image: 'immunedisorder_2' }
      ]
    },
    {
      label: 'Insomnia/ poor sleep quality',
      label_show: 'การนอนผิดปกติ',
      page: 6,
      Xpos_image: '295px',
      Ypos_image: '858px',
      Xlabel: '287px',
      Ylabel: '933px',
      width: '70px',
      height: 'auto',
      result_comp: [
        { min: 0, max: 3, image: 'insommnia_0' },
        { min: 4, max: 6, image: 'insommnia_1' },
        { min: 7, max: 100, image: 'insommnia_2' }
      ]
    },
    {
      label: 'Stress and anxiety',
      label_show: 'ภาวะซึมเศร้าและเครียด',
      page: 6,
      Xpos_image: '426px',
      Ypos_image: '858px',
      Xlabel: '408px',
      Ylabel: '933px',
      width: '70px',
      height: 'auto',
      result_comp: [
        { min: 0, max: 3, image: 'stress_0' },
        { min: 4, max: 6, image: 'stress_1' },
        { min: 7, max: 100, image: 'stress_2' }
      ]
    },
]


export const diseases_image_bwcdiamond_eng = [
  // {
  //   label: 'Eczema',
  //   label_show: 'Eczema',
  //   page: 12,
  //   Xpos_image: '77px',
  //   Ypos_image: '685px',
  //   Xlabel: '90px',
  //   Ylabel: '757px',
  //   width: '70px',
  //   height: 'auto'
  // },
];

export const diseases_image_bwcdiamond_thai = [
  // {
  //   label: 'Eczema',
  //   label_show: 'Eczema',
  //   page: 12,
  //   Xpos_image: '77px',
  //   Ypos_image: '685px',
  //   Xlabel: '90px',
  //   Ylabel: '757px',
  //   width: '70px',
  //   height: 'auto'
  // },
];